module.exports = __webpack_public_path__ + "static/og-84d0c2fc927be5b54a1639977d7f1bc2.png";